const Form053EN = {
    stepName: {
        importantNotes: "Important Notes",
        information: "Information",
        SelectApplyType: "Selection of Section(s)",
        SectionA: "Section A",
        SectionB: "Section B",
        certification: "Certification",
    },
    title: {
        note: "Note",
        noteTitle: "Personal Information Collection Statement",
        schoolInformation: "School Information",
        CGHP: "Cash Grant for Houseparent (CGHP)",
        selectMessage: "Please select you need: ",
        sectionACGHP: "Section A:CGHP in exchange for vacant HP posts",
        vacancyPeriod: "Period of Freezing of Vacancy (not less than 30 days)",
        vacantPost: "Vacant Post",
        indicateDocuments: "Please indicate the following documents:",
        sectionBCGHP:
            "Section B:CGHP in lieu of temporary replacement for HP(s) on approved leave of not less than 30 days",
        leaveInformation: "Information on the HP(s) on leave",
        CGHPInformation: "CGHP Information",
        applyTitle: "Please select the required allowance application:",
    },
    label: {
        revokeOrNot: "Please choose as appropriate",
        irrevocable: "Irrevocable",
        revocable: "Revocable",
        revokOptions: {
            irrevocable: "Irrevocable",
            revocable: "Revocable",
        },
        revokeRefLabel: "Please input amount as appropriate",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        statementTwo:
            "I understand the applicant and the teacher need to have an “iAM Smart+” account to process the application.",
        schoolName: "Name of School",
        schoolCode: "School Code",
        month: "Month",
        year: "Year",
        situationOfCGHP: "The situation of CGHP",
        from: "Period From",
        to: "Period To",
        schoolYear: "School Year",
        houseparentTotalNumber:
            "(a) Total number of houseparent (HP) posts in the establishment",
        irrevocableNumber:
            "(b) Number of irrevocable freezing of vacant HP post(s)",
        irrevocableDate: "Date of letter of approval from EDB",
        revocableNumber:
            "(c) Number of revocable freezing of vacant HP post(s)",
        revocableDate: "Date of letter of approval from EDB",
        attachment: "Approval Letter",
        attachment1: "MPF Supporting Information",
        attachment2: "Attachment",
        vacantPercentage:
            "(d) Percentage of vacant HP post(s) encashed [(b+c)/(a)*100%]",
        periodText: `I would like to declare the following: `,
        periodText1: `For the period from `,
        periodText2: `to `,
        periodText3: `in the `,
        periodText4: `school year, the situation of CGHP in my school`,
        periodText5: `is as follows`,
        sectionACGHPText: "Section A: CGHP in exchange for vacant HP posts",
        sectionBCGHPText:
            "Section B: CGHP in lieu of temporary replacement for HP(s) on approved leave of not less than 30 days",
        sectionANote2: "Please tick as appropriate",
        sectionANote3: "Number of Qualified Months",
        sectionANote4: "Vacant Post Monthly Salary",
        sectionANote5: "Vacant Post MPF Subsidy",
        sectionACGHPAmount: "CGHP Amount",
        irrevocableTotal: "Total (Irrevocable) ",
        revocableTotal: "Total (Revocable)",
        amountTotal: "Total (CGHP Amount)",
        claim: "New Claim Post/Revised Claim",
        claimOptions: {
            N: "New Claim Post",
            R: "Revised Claim",
        },
        previousClaim:
            "Unchange Previous Claim/Delete Previous Claim/Change Previous Claim",
        previousClaimOptions: {
            U: "Unchange Previous Claim",
            D: "Delete Previous Claim",
            C: "Change Previous Claim",
        },
        applicationNumber:
            "Please indicate the application number of previous claim form",
        applicationNumberErr: "application number",
        previousClaimDate: "Copy of previous claim dated",
        freezingFrom: "Period of Freezing of Vacancy From",
        freezingTo: "Period of Freezing of Vacancy To",
        datedAttached: "Copy of previous claim dated attached",
        remark: "Remark",
        fileSize: "The maximum size of each file is: 5MB",
        fileType: "Acceptable file types: PDF, JPEG, PNG",
        fileNum: "Maximum number of files: 8",
        name: "Name",
        SRN: "SRN",
        post: "No. of Posts",
        leavePeriodFrom: "Leave Period From",
        leavePeriodTo: "Leave Period To",
        absenceReason: "Reason for Absence",
        CGHPInformation: "Information on CGHP",
        qualifiedPeriodFrom: "Qualified Period From",
        qualifiedPeriodTo: "Qualified Period To",
        qualifiedMonthNo: "No. of qualified month (a)",
        monthlySalary: "Monthly Salary (b)",
        MPFSubsidy: "MPF Subsidy (c)",
        sectionBCGHPAmount: "CGHP Amount (d) = (a) * (b) + (c)",
        certify: "I certify that: ",
        freezingPeriod: "THe Period of Freezing of Vacancy",
        leavePeriod: "The leave period",
        contactPerson: "Contact Person",
        tel: "Tel No.",
        sSDO: "SSDO",
        sSDOValue: {
            0: "Central & Western District",
            1: "Southern District",
            2: "Wan Chai District",
            3: "Islands District",
            4: "Hong Kong East District",
            5: "Kowloon City District",
            6: "Sham Shui Po District",
            7: "Sai Kung District",
            8: "Kwun Tong District",
            9: "Wong Tai Sin District",
            10: "Yau Tsim & Mong Kok District",
            11: "Tai Po District",
            12: "North District",
            13: "Sha Tin District",
            14: "Kwai Chung & Tsing Yi District",
            15: "Tsuen Wan District",
            16: "Tuen Mun District",
            17: "Yuen Long District",
        },
    },
    message: {
        exceedsHPposts:
            "Percentage of vacant HP post(s) encashed exceeds the cap of 40%",
        toMessage: "To: Recurrent Subventions Section, Education Bureau",
        attnMessage: "[Attn.:  AOI(RS)]",
    },
    errorMsg: {
        least30Days:
            "The leave period is below 30 calendar days, please choose again",
        freezing30Days:
            "Period of freezing of vacancy must not be less than 30 calendar days",
        E001: "must be alpha-numeric",
        E002: "The start of the qualifying period cannot be earlier than the start of the leave period",
        maxDigitADecimal:
            "This field must be at most {{maxDigit}} digits and decimal places",
        maxTextLength: "This field must be at most {{max}} characters",
        afterDate: "Please select a date in or after {{date}}",
        noLeadingZero: "Numbers cannot start with 0",
        afterAug31:
            "Leave period should not later than 31 Aug of the subject school year",
        freezingToAfterAug31:
            "Period of Freezing of Vacancy should not later than 31 Aug of the subject school year",
        qualifiedToAfterAug31:
            "Qualified period should not later than 31 Aug of the subject school year",
        withinSchoolYear: "Out of range for the school year",
        schoolYearFormat: 'The school year format must be "XXXX/YYYY"',
    },
    monthOption: {
        jan: "01",
        feb: "02",
        mar: "03",
        apr: "04",
        may: "05",
        jun: "06",
        jul: "07",
        aug: "08",
        sep: "09",
        oct: "10",
        nov: "11",
        dec: "12",
    },
    note: {
        note1: `1. Special schools may encash vacant HP posts up to 20% of the HP establishment of each school year provided that the
        majority of the HP consent to such encashment has been obtained in advance and the quality of boarding services will
        not be adversely affected. If a special school intends to encash vacant HP posts beyond 20% of the HP establishment, prior approval shall be sought from the Education Bureau (EDB) before the school makes any arrangements for
        employing additional staff. The school is required to submit its application with justifications for prior approval in writing
        to Special Education Support 1 Section (SES1 Section), EDB, at 5/F., East Wing, Central Government Offices, 2 Tim Mei
        Avenue, Tamar, Hong Kong, for consideration. While the approval for revocable freezing of vacant HP posts will be valid
        for the school year in question only, the approval for irrevocable freezing of vacant HP posts (including those approved
        before the effective date of this circular) will be valid for the school year in question and in subsequent school years so
        long as the number of HP posts approved to be frozen and encashed on an irrevocable basis falls at or below the cap of
        40%. In case a change of HP establishment results in the number of HP posts approved in a previous year to be frozen
        and encashed exceeding the cap of 40% of the HP establishment in a school year, the number of frozen and encashed HP
        posts so approved will be revised downward until it falls at or below the cap of 40% of the HP establishment in that
        school year and in subsequent school years. Under no circumstances shall the encashment of the vacant HP posts
        exceed 40% of the HP establishment of each school year. If the cap of encashment of 20% or 40% of the HP
        establishment results in a fractional number of HP posts for a particular school, the fractional number will be rounded
        down to the nearest whole number. The school is required to submit its claim form to Recurrent Subventions Section
        with relevant approval letter from SES1 Section for encashment of vacant HP posts that exceeds 20% of the HP
        establishment of each school year.`,
        note2: `2. Both application for irrevocable and revocable freezing and encashment of HP post(s) should be made on an annual
        basis. Schools are required to submit the claim form within the respective school year.`,
        note3: `3. Calculate the number of qualified months from the starting date to the ending date (both dates inclusive) for CGHP by adding up the following 3 elements:`,
        note4: `(i) the proportion of qualified number of days, if any, in the starting month to its total number of calendar days;`,
        note5: `(ii) number of completed calendar months, if any; and`,
        note6: `(iii) the proportion of qualified number of days, if any, in the ending month to its total number of 
        calendar days`,
        note7: `For example:`,
        note8: `Assuming the Qualified Period for CGHP starts from 5 February to 26 May, the Number of Qualified Months should be
        calculated as follows:`,
        note9: `(i) 24 being number of days in the starting month (5 to 28 February) divided by 28 (the total number of days in
            February) = 0.857 months;`,
        note10: `(ii) 2 being number of completed calendar months of March and April;`,
        note11: `(iii) 26 being number of days in the ending month (1 to 26 May) divided by 31 (being the total number of days in May) =
        0.839 months; and`,
        note12: `(iv) The Number of Qualified Months should be the sum of the above 3 elements (rounded at 3 decimals), i.e. 0.857 + 2
        + 0.839 = 3.696.`,
        note13: `4. Enter the mid point salary of the HP post. With effect from the 2013/14 school year, the mid point salary of a HP is
        at Master Pay Scale (MPS) Point 16`,
        note14: `5. Employer's contribution to MPF Schemes (5% of the monthly salary capped at maximum amount stipulated under
            prevailing MPF regulations) will be included if the qualified period is of 60 days or more. For the period of leave of less
            than 60 calendar days and the temporary replacement for HP is required to contribute to MPF, please provide supporting
            information.`,
        note15: `6. Enter Staff Reference Number of the HP on leave.`,
        note16: `7. Please note that granting of leave should follow EDB Circular No. 1/2006.`,
        note17: `(i) consent has been obtained from my school's IMC/SMC and the majority of HP(s) for freezing the HP post(s) under Section A in the
        above-mentioned period in the school year;`,
        note18: `(ii) the frozen HP post(s) claiming CGHP under Section A arises from vacant regular post(s) during the claim period and this request for payment
        complies with the conditions set out for CGHP applications;`,
        note19: `(iii) no duplicate claim has been made for government subventions on account of the same leave/vacancy set out in Sections A and B.`,
        note20: `Applicants should read carefully and agree`,
        note21: `Notes on private data`,
        note22: `N: New claim post / R: Revised claim (Copy of previous claim dated: ______________________________________attached)`,

        note23: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s): ",
        note24: "(a) processing employment-related matters;",
        note25: "(b) processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        note26: "(c) auditing;",
        note27: "(d) conducting research and compiling statistics to facilitate planning of education services;",
        note28: "(e) processing matters relating to the development of the education profession;",
        note29: "(f) administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",
        note30: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note31: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
        note32: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note33: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },
};
export default Form053EN;
